// extracted by mini-css-extract-plugin
export default {"title":"StageMapping_title__+IOp+","statusWrap":"StageMapping_statusWrap__2SM7f","saveBtn":"StageMapping_saveBtn__v66L-","doneBtn":"StageMapping_doneBtn__kRBQ9"};